import { Component } from 'vue-property-decorator';
import Rs4ComponentBase from '@/shared/application/rs4-component-base';
import LanguageStore from '@/stores/language-store';

@Component
export default class RegisterComponent extends Rs4ComponentBase {
    refs = this.$refs as any;
    registerInput = {} as IRegisterInput;
    errors: INameValueDto[] = [];
    resultMessage: string | undefined;
    registerComplete = false;

    errorValues: string[] = [];
    errorFields: string[] = [];

    selectedLanguage = {} as ILanguageDto;

    onSubmit() {
        if (this.refs.form.validate()) {
            this.rs4Service.post<IRegisterOutput>('/api/auth/signup', this.registerInput)
                .then((response) => {
                    debugger;
                    if (!response.isError) {
                        this.resultMessage = this.$t('AccountCreationSuccessful').toString();
                        this.registerComplete = true;
                    } else {
                        this.errorFields = [];
                        this.errorValues = [];
                        this.errors = response.errors;

                        this.errors.forEach((value, i) => {
                            this.errorFields.push(value.name);
                            this.errorValues.push(value.value);
                        });
                        this.$v.$reset();
                        this.$v.$touch();                       
                    }
                });
        }
    }


    created(){

    }

    beforeMount() {
        this.selectedLanguage = LanguageStore.getLanguage();

        
    }

     changeLanguage(languageCode: string, languageName: string) {
        debugger;         
        this.$i18n.locale = languageCode;
        this.selectedLanguage = { languageName, languageCode } as ILanguageDto;
        this.$vuetify.lang.current = languageCode;

        LanguageStore.setLanguage({
            languageCode,
            languageName
        } as any);
    }
}